// Register service worker only in production builds so dev reloads stay instant.
// Used in Capacitor + Firebase Hosting deploys; on localhost dev the SW is skipped.
export function registerPWA() {
  if (!('serviceWorker' in navigator)) return;
  if ((import.meta as any).env?.DEV) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
      console.warn('[Clientale] SW registration failed:', err);
    });
  });
}
